<template>
  <el-upload
    drag
    ref="upload"
    :accept="accept"
    :headers="headers"
    :show-file-list="false"
    :on-success="onSuccess"
    :before-upload="beforeUpload"
    :limit="maxLen"
    :action="uploadUrl"
  >
    <i
      v-if="imageUrl1"
      class="el-icon-circle-close deleteImg"
      @click.stop="handleRemove1"
    ></i>
    <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />

    <div v-else>
      <i
        class="el-icon-picture"
        style="margin-top: 40px; font-size: 40px; color: #999a9c"
      ></i>
      <div class="el-upload__text1">上传图片</div>
      <div class="el-upload__text">* 建议尺寸比例2.2:1，不超过4m，</div>
      <div class="el-upload__text">格式为png、jpeg或jpg</div>
    </div>
  </el-upload>
</template>
<style scoped>
.deleteImg {
  font-size: 30px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
}
</style>
<script>
import store from "@/store";

export default {
  props: {
    value: {
      type: [String, Array],
      default: ""
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    limtSize: {
      type: Number,
      default:4
    },
    isMultiple: { //是否开启多图上传 如果开启 不可使用v-model双向绑定 使用uploadChange接收
      type: Boolean,
      default: false
    },
    maxLen: {
      type: Number,
      default:1
    },
    accept: {
      type: String,
      default:".jpeg,.jpg,.png,.gif",
    },
    pic :{
      type: String,
      default:"",
    }

  },
  data() {
    return {
      upLoading: false,
      dataObj:{},
      clickImgUrl:"",
      fileList: [],
      uploadUrl:'/admin/sys-file/upload',
    }
  },
  computed: {
    imageUrl1: function() {
      return this.pic;
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt = (file.size / 1024) < this.limtSize*1024;
      const suffix = file.name.split('.').pop().toLowerCase();
      if (this.accept.indexOf(`.${suffix}`) == -1) {
        this.$message.error('上传文件格式不正确！');
        return false;
      }
      if (!isLt) {
        this.$message.error('上传文件大小不能超过'+ this.limtSize +'M');
        return false
      }
    },
    onSuccess(res, file, list) {
      this.imageUrl1 = "";
      this.imageUrl1 = res.data.url;
      this.$refs.upload.clearFiles();
      this.$emit("getUploadPic", res.data.url);
    },
    // 删除只需清空imageUrl1即可
    handleRemove1(file, fileList) {
      this.imageUrl1 = "";
      this.$emit("getUploadPic", "");
    },

  },
}
</script>

<style lang="scss" scoped>
.img-upload-component {
  ::v-deep  {
    // 删除离开动画
    .el-list-leave-to,
    .el-list-leave-active{
      display: none;
    }

  }

}

</style>
